import { Component, OnInit } from '@angular/core';
import { ProspectService } from 'services/prospect.service';
import { Prospectagreed } from '../../models/prospectagreed';
import { Router, ActivatedRoute } from '@angular/router';
import { SplashService } from 'services/splash.service';

@Component({
  selector: 'app-tour-agree',
  templateUrl: './tour-agree.component.html',
  styleUrls: ['./tour-agree.component.css']
})
export class TourAgreeComponent implements OnInit {

  model: Prospectagreed = new Prospectagreed();
  errorMessage: string;
  tourType: string = null;
  agreeToWarning: boolean = true;

  constructor(private prospectService: ProspectService, public router: Router, public route: ActivatedRoute, private splashService: SplashService) {

    let address = localStorage.getItem('PropertyAddress');
    let tourtype = localStorage.getItem('TourType');

    if (address !== null && address !== undefined)
    {
      this.model.Address = address;
    }
    if (tourtype !== null && tourtype !== undefined)
    {
      this.tourType = tourtype;
      if(this.tourType === "selftour"){
        this.agreeToWarning = false;
      }
      this.prospectService.getCostAndValidDays().subscribe(res => this.onGetTourCost(tourtype, res), res => this.errorMessage = res);
    }
    
   }

  ngOnInit() {
    this.errorMessage = null;

    if (this.tourType === "openhouse")
    {
      this.splashService.updateSplash("openhouse");
    }
    else if(this.tourType === "showing")
    {
      this.splashService.updateSplash("agenttour");
    }
    else if(this.tourType === "selftour")
    {
      this.splashService.updateSplash("selftour");
    }

  }

  onGetTourCost(tourType: string, tourCost: string)
  {
    this.model.LoadTourType(tourType, tourCost);
  }

  onSubmit() {
    
    if (this.model.TourType === "openhouse")
    {
      this.router.navigate(['/tour/openhouseselect']);
    }
    else if (this.model.TourType === "showing")
    {
      this.router.navigate(['/tour/showingdateselect']);
    }
    else if (this.model.TourType === "selftour")
    {
      this.prospectService.SelfTourSchedulingStarted(localStorage.getItem('YardiID')).subscribe();
      this.prospectService.CheckProspectStatus();
    }
  }

}
